import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const CPViewParticipantMainWrapper = styled.div`
  gap: 32px;
  display: flex;
  flex-direction: column;

  .header-left {
    margin: 4px 0px 16px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    align-items: center;
  }
  ${responsive.MOBILE`
    gap: 0;
  `}

  .MuiGrid2-root {
    padding-right: 16px;

    ${responsive.MOBILE`
      padding-right: 0;
    `}
  }
  .MuiTabs-flexContainer {
    border-bottom: 2px solid ${COLORS.cirrus_black3};
  }
  .header-collapse {
    margin: 16px;
    text-align: end;
    ${responsive.MOBILE`
      margin: 8px;
    `}
  }
  .accordion-header {
    margin: 26px 0px;
  }
  .coach-assignment-container,
  .address-details {
    margin: 24px 16px 24px 16px;
  }
  .program-status {
    margin: 24px 0px 0px 16px;
  }
  .participant-tab {
    .header-collapse {
      margin-bottom: 0;
    }
    .MuiPickersTextField-root,
    .MuiPickersInputBase-root {
      width: 100%;
    }

    .participant-accordion {
      margin-top: 16px;
      margin-bottom: 32px;
    }
    .participant-accordion:last-child {
      margin-bottom: 16px;
    }
  }

  .bottom-button-container {
    padding: 32px 16px 20px 0px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: ${COLORS.cirrus_white};
    gap: 16px;

    ${responsive.MOBILE`
      padding: 16px 8px;
      justify-content: center;
      flex-direction: column-reverse;
      margin-top: 16px;
      margin-bottom: 16px;
    `}

    .btn-secondary {
      ${responsive.MOBILE`
        width: 100%;
      `}
    }
  }
`;
